<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>To the memory of Ali Abdoh, old Tehran’s boss of bosses, and to his grandson, Ashil.</i></p>
<p class="ded1"><i>In addition to the remarkable efforts and patience of the writers themselves, there are several friends who should be especially acknowledged in this anthology: Hooshyar Ansaarifar, Mitra Elyati, Maryam Haidari, Somayeh Nasiriha, and Hassan Shahsavari. A warm thanks to each and every one of you for your invaluable suggestions and encouragement. This book could not have come together as it did without you.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedt.vue?82106dcc